import React, { useState, useRef } from "react";
import styled from "styled-components";
import { useLanguage } from "../../LangTranslation/LanguageContext";
import FormikSelect from "../../Formik/FormikSelect";
import FormikInput from "../../Formik/FormikInput";
import { TABLE_CELL_INPUT_MINIMUM_WIDTH } from "../../../utilities/constants";
import SVGButton from "../../Buttons/SVGButton";
import deleteIcon from "../../../Images/Delete.svg";
import useListOptions from "../../../CustomHooks/useListOptions";
import { findAndAddOption } from "../../../utilities/findAndAddOption";
import { useFormikContext } from "formik";
import UploadedImage from "../../UploadedImagedComponent/UploadedImage";
import { fileToBase64 } from "../../../utilities/fileToBase64";
import { checkBase64Type } from "../../../utilities/checkFileType";
import editIcon from "../../../Images/edit.svg";
import useConfirmationModal from "../../ConfirmationModal/useConfirmationModal";
import { useSession } from "../../../authentications/SessionContext";
import { enqueueSnackbar } from "notistack";
import { getWebContent } from "../../../DataApi/Company/getWebContent";
import { getToken } from "../../../authentications/getCSRFToken";
import { primaryColor } from "../../../utilities/colors";

const TableContainer = styled.div`
  width: 100%;
  background-color: #fff;
  border-radius: 15px;
  // padding: 20px;
  overflow: auto;
  .table tbody tr td,
  .table thead tr {
    padding: 21px !important;
    font-family: "Inter", sans-serif;
    border-bottom: 0px !important;
    font-weight: 600;
  }

  .table th {
    background-color: #f8f9fa !important;
    padding: 15px !important;
    color: #4e5d78 !important;
    font-family: "Inter", sans-serif;
    font-size: 14px;
  }

  tbody tr:hover {
    background-color: #f4f8ff;
  }
`;
const Button = styled.button`
  background-color: #fff;
  color: #ff5837;
  border: none;
  font-weight: 600;
  width: 130px;
  min-width: 150px;
  height: 40px;
  margin-right: 110px;
  outline: none;
`;

const Documents = ({
  keyName,
  disabled,
  context,
  company_id,
  bankList,
  form,
  name,
  push,
  replace,
}) => {
  // console.log(bankList, "bankList");
  const { language, translations } = useLanguage();
  const t = translations[language];
  const { sessionInfo } = useSession();
  const { isVTEX } = sessionInfo;
  const { values, setFieldValue } = form;
  const { bank_ids } = values;
  // console.log(bank_ids, sessionInfo.isVTEX, "bank_ids");
  const {
    options: stateList,
    setOptions: setStateList,
    handleCustomSearch,
  } = useListOptions();
  const { ConfirmationModal, toggleModal, setMetaData, setTitle } =
    useConfirmationModal();

  const fileInputRef = useRef();
  const fileInputRefVc = useRef();
  const fileInputRefCc = useRef();
  const addRow = () => {
    push({
      acc_holder_name: false,
      acc_number: false,
      bank_id: false,
      branch_name: false,
      cr_img: false,
      vc_img: false,
      cc_img: false,
      sequence: 10,
      isDeleted: false,
      id: `virtual_${Math.random() * 1000}`,
    });
  };
  const removeRow = (index) => {
    replace(index, { ...bank_ids[index], isDeleted: true });
  };

  const handleImageUpload = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      // console.log("file uploaded.......", file, e.target);
      const maxSizeInBytes = 10 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        toggleModal();
        setTitle("File Size Limit Reached!");
        setMetaData({
          primaryButton: "",
          secondaryButton: "Ok",
          dangerouslySetInnerHTML: "File size must be less or equal to 10MBs.",
        });
      } else {
        const { name: fieldName } = e.target;
        // let fieldSet = `${name}.${index}.${fieldName}`;
        // console.log("name.......fieldName", fieldSet);
        fileToBase64(file, (_, base64) => {
          setFieldValue(`${name}.${index}.${fieldName}`, base64 || "");
        });
      }
    }
  };
  const handleDownload = async (bankList, index, type) => {
    // console.log("file to download", bankList, index, type);
    const fileToDownload = bankList?.[index]?.[type];
    const recordId = bankList?.[index]?.id;
    // console.log("record id", recordId);
    if (fileToDownload) {
      try {
        const result = await getToken();
        const myCSRF = result?.token;
        // console.log("myCSRF", myCSRF);
        if (myCSRF) {
          const formdata = new FormData();
          formdata.append("model", "res.partner.bank");
          formdata.append("id", recordId);
          formdata.append("field", type);
          formdata.append("filename_field", "undefined");
          formdata.append("filename", "");
          formdata.append("download", "true");
          formdata.append("data", fileToDownload);
          formdata.append("token", "dummy-because-api-expects-one");
          formdata.append("csrf_token", myCSRF);
          const dataObject = {};
          formdata.forEach((value, key) => {
            dataObject[key] = value;
          });

          // console.log("form data", dataObject);
          const downloadResponse = await getWebContent(formdata, dataObject);
          if (downloadResponse) {
            // Function to convert Base64 string to ArrayBuffer
            function base64ToArrayBuffer(base64) {
              const binaryString = atob(base64);
              const len = binaryString.length;
              const bytes = new Uint8Array(len);

              for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i);
              }

              return bytes.buffer;
            }

            // Function to create a Blob from Base64 string
            function base64ToBlob(base64, mimeType) {
              const arrayBuffer = base64ToArrayBuffer(base64);
              return new Blob([arrayBuffer], { type: mimeType });
            }

            // "application/vnd.openxmlformats-officedocument.spreadsheetml.shee"; // MIME type for ZIP files

            const blob = base64ToBlob(fileToDownload, "");
            let fileName = "";
            downloadResponse.headers.forEach(function (val, key) {
              if (key === "content-disposition") {
                const splitList = val?.split(`'`);
                fileName = splitList[splitList.length - 1] || "";
              }
            });
            // Optionally, create a URL for the Blob and download it
            if (fileName) {
              const url = URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = fileName; // Replace with desired filename
              a.click();
              URL.revokeObjectURL(url);
            }

            return;
          } else {
            enqueueSnackbar(
              "Something went wrong, while downloading the attachment!",
              {
                variant: "error",
                preventDuplicate: true,
              }
            );
          }
        } else {
          enqueueSnackbar(
            "Something went wrong, while downloading the attachment!",
            {
              variant: "error",
              preventDuplicate: true,
            }
          );
        }
      } catch (error) {
        console.log("Error occured while downloading", error);
      }
    } else {
      enqueueSnackbar("Attachment not found. Something went wrong!", {
        variant: "warning",
        preventDuplicate: true,
      });
    }
  };
  const getFileType = (base64) => checkBase64Type(base64 || "");
  return (
    <div>
      <ConfirmationModal />
      <TableContainer>
        <table className="table">
          <thead>
            <tr className="heading_row">
              <th
                className="text-center"
                style={{ minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH }}
              >
                {t["Commercial Registration"]}
              </th>
              <th
                className="text-center"
                style={{ minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH }}
              >
                {t["VAT Certificate"]}
              </th>
              <th
                className="text-center"
                style={{ minWidth: TABLE_CELL_INPUT_MINIMUM_WIDTH }}
              >
                {t["Chamber of Commerce"]}
              </th>
              <th className="text-center" style={{ minWidth: 50 }} />
            </tr>
          </thead>
          <tbody>
            {bank_ids
              .filter((bank) => bank.isDeleted === false)
              .map((bank, index) => {
                var fileName = getFileType(bank.cr_img) || "";
                // console.log("fileName......", fileName);
                var fileNameVc = getFileType(bank.vc_img) || "";
                var fileNameCc = getFileType(bank.cc_img) || "";
                return (
                  <tr key={index}>
                    <td className="align-middle">
                      <div className="align-middle" style={{ height: "56px" }}>
                        <div
                          style={{
                            border: "1px solid #cbcbcb",
                            height: "inherit",
                            borderRadius: "15px",
                          }}
                          disabled={disabled}
                          role="button"
                          onClick={() => fileInputRef.current.click()}
                          className="p-1 d-flex justify-content-center align-items-center"
                        >
                          {fileName ? (
                            <>
                              <span className="text-center w-100">
                                ({fileName})
                              </span>
                              <span>
                                {!disabled && (
                                  <i className="text-primary fas fa-edit me-1"></i>
                                )}
                              </span>
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setFieldValue(`${name}.${index}.cr_img`, "");
                                  // console.log(
                                  //   "remove uploaded file",
                                  //   name,
                                  //   index
                                  // );
                                }}
                              >
                                {!disabled && (
                                  <i className="text-danger fas fa-trash-alt me-1"></i>
                                )}
                              </span>
                              <span
                                className="text-center"
                                title="Download CR"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleDownload(
                                    values.bank_ids,
                                    `${index}`,
                                    "cr_img"
                                  )
                                }
                              >
                                <i className="text-secondary fas fa-download me-1"></i>
                              </span>
                            </>
                          ) : (
                            t["Upload CR"]
                          )}
                        </div>
                        <input
                          ref={fileInputRef}
                          disabled={disabled}
                          onChange={(e) => handleImageUpload(e, `${index}`)}
                          type="file"
                          name="cr_img"
                          hidden
                          // accept="text/plain,.odp ,.doc, .docx, .xls, .xlsx, .pdf, .csv, .txt, images/*"
                        />
                      </div>
                    </td>
                    <td className="align-middle">
                      <div className="align-middle" style={{ height: "56px" }}>
                        <div
                          style={{
                            border: "1px solid #cbcbcb",
                            height: "inherit",
                            borderRadius: "15px",
                          }}
                          disabled={disabled}
                          role="button"
                          onClick={() => fileInputRefVc.current.click()}
                          className="p-1 d-flex justify-content-center align-items-center"
                        >
                          {fileNameVc ? (
                            <>
                              <span className="text-center w-100">
                                ({fileNameVc})
                              </span>
                              <span>
                                {!disabled && (
                                  <i className="text-primary fas fa-edit me-1"></i>
                                )}
                              </span>
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setFieldValue(`${name}.${index}.vc_img`, "");
                                  // console.log("remove uploaded file", values);
                                }}
                              >
                                {!disabled && (
                                  <i className="text-danger fas fa-trash-alt me-1"></i>
                                )}
                              </span>
                              <span
                                className="text-center"
                                title="Download VC"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleDownload(
                                    values.bank_ids,
                                    `${index}`,
                                    "vc_img"
                                  )
                                }
                              >
                                <i className="text-secondary fas fa-download me-1"></i>
                              </span>
                            </>
                          ) : (
                            t["Upload VC"]
                          )}
                        </div>
                        <input
                          ref={fileInputRefVc}
                          disabled={disabled}
                          onChange={(e) => handleImageUpload(e, `${index}`)}
                          type="file"
                          name="vc_img"
                          hidden
                          // accept="text/plain,.odp ,.doc, .docx, .xls, .xlsx, .pdf, .csv, .txt, images/*"
                        />
                      </div>
                    </td>
                    <td className="align-middle">
                      <div className="align-middle" style={{ height: "56px" }}>
                        <div
                          style={{
                            border: "1px solid #cbcbcb",
                            height: "inherit",
                            borderRadius: "15px",
                          }}
                          disabled={disabled}
                          role="button"
                          onClick={() => fileInputRefCc.current.click()}
                          className="p-1 d-flex justify-content-center align-items-center"
                        >
                          {fileNameCc ? (
                            <>
                              <span className="text-center w-100">
                                ({fileNameCc})
                              </span>
                              <span>
                                {!disabled && (
                                  <i className="text-primary fas fa-edit me-1"></i>
                                )}
                              </span>
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setFieldValue(`${name}.${index}.cc_img`, "");
                                  // console.log("remove uploaded file", values);
                                }}
                              >
                                {!disabled && (
                                  <i className="text-danger fas fa-trash-alt me-1"></i>
                                )}
                              </span>
                              <span
                                className="text-center"
                                title="Download CC"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleDownload(
                                    values.bank_ids,
                                    `${index}`,
                                    "cc_img"
                                  )
                                }
                              >
                                <i className="text-secondary fas fa-download me-1"></i>
                              </span>
                            </>
                          ) : (
                            t["Upload CC"]
                          )}
                        </div>
                        <input
                          ref={fileInputRefCc}
                          disabled={disabled}
                          onChange={(e) => handleImageUpload(e, `${index}`)}
                          type="file"
                          name="cc_img"
                          hidden
                          // accept="text/plain,.odp ,.doc, .docx, .xls, .xlsx, .pdf, .csv, .txt, images/*"
                        />
                      </div>
                    </td>

                    <td className="align-middle">
                      {!disabled && (
                        <SVGButton
                          onClick={() => removeRow(index)}
                          icon={deleteIcon}
                          hoverColor="silver"
                        />
                      )}
                    </td>
                  </tr>
                );
              })}
            {bank_ids.filter((bank) => bank.isDeleted === false)?.length ===
              0 && (
              <tr>
                <td colSpan={5} className="text-center">
                  No Data Available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </TableContainer>

      {!disabled && (
        <Button
          role="button"
          type="button"
          disabled={disabled}
          onClick={addRow}
          style={{ color: isVTEX ? primaryColor.primary : "#ff5837" }}
        >
          + Add Document
        </Button>
      )}
    </div>
  );
};

export default Documents;
